<div *ngIf="isLoading">
    <po-loading-overlay [p-text]="text" [p-size]="size" />
</div>

<app-modal-terminal-select #modalTerminal (selected)="onTerminalSelected($event)"
    (cancel)="terminalModalClosed()"></app-modal-terminal-select>
<app-toaster></app-toaster>

<po-page-default>
    <div class="row po-font-text-small po-mb-3 po-mt-1">
        <app-step-breadcrumb [breadcrumbs]="breadcrumbs" [activeIndex]="orderCountStep"
            (breadcrumbClick)="navigateBreadcrumb($event)"></app-step-breadcrumb>
    </div>
    <div *ngIf="terminal !== ''" class="po-mb-5">
        <div *ngIf="orderCountStep == OrderCountStepEnum.OrderHeader">
            <app-order-header #orderHeaderComponent [terminalSelected]="terminal" (isLoading)="onLoadingChange($event)"
                (orderSelected)="onOrderHeaderSelected($event)"
                (onTerminalModalOpen)="onTerminalModalOpen()"></app-order-header>
        </div>

        <div *ngIf="orderCountStep == OrderCountStepEnum.OrderCount">
            <app-order-count-header [orderModel]="orderModel!" (isLoading)="onLoadingChange($event)"
                [terminalSelected]="terminal" (orderCountSelected)="onOrderCountSelected($event)"
                (onTerminalModalOpen)="onTerminalModalOpen()" />
        </div>
        <div *ngIf="orderCountStep == OrderCountStepEnum.OrderCountDetail">
            <app-order-count-detail (isLoading)="onLoadingChange($event)" [orderModel]="orderModel!"
                [orderCountModel]="orderCountModel!" [terminalSelected]="terminal"
                (onCountFinished)="onOrderCountFinished()" />
        </div>
    </div>
</po-page-default>